import React from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemModelTableRow } from "../model/qq-key-info-item.model";
import { TableRow } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { withStyles } from "@mui/styles";
import {
  ResTableNameTypography,
  ResTableValueTypography,
} from "./qq-typohraphy.controls";

export type QqResRowControlProps = StateDispatchProps &
  QqKeyInfoItemModelTableRow;

const StyledCell = withStyles((theme) => {
  return {
    root: {
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      borderTop: "1px solid rgba(224, 224, 224, 1)",
    },
  };
})(TableCell);

export const QqResRowControl: React.FunctionComponent<QqResRowControlProps> = ({
  name,
  value,
  help,
}) => {
  return (
    <TableRow>
      <StyledCell size={"small"}>
        <ResTableNameTypography>{name}</ResTableNameTypography>
      </StyledCell>
      <StyledCell size={"small"}>
        <ResTableValueTypography>{value}</ResTableValueTypography>
      </StyledCell>
    </TableRow>
  );
};
